/**
 * @file
 * Example of a custom script file.
 */
(function ($, Drupal) {
  Drupal.behaviors.global = {
    attach: function (context) {
      $(once('remove-h1-next-p', 'body.node-8 h1', context)).next('p').remove();
    }
  };
})(jQuery, Drupal);
